import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gobierno-corporativo',
  templateUrl: './gobierno-corporativo.component.html',
  styleUrls: ['./gobierno-corporativo.component.scss']
})
export class GobiernoCorporativoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
